/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
import ChevronRightLogo from '@mui/icons-material/ChevronRightRounded';
import ExternalLinkLogo from '@mui/icons-material/OpenInNewRounded';
import { Box, Divider, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { useState } from 'react';
import ATCOButton from '../../../common/ATCOButton';
import { TypographyVariants } from '../../../theme/TypographyVariants';
import { ButtonType } from '../../../types/enums';
import useResponsiveHelper from '../../common/hooks/useResponsiveHelper';
import { Navigation } from '../Header';
import BodyFourthLevelMenu from './BodyFourthLevelMenu';

interface BodyThirdLevelMenuProps {
    subMenuClicked: boolean;
    menuItem: string;
    mainMenuItem: string;
    setSubMenuItem: (subMenuItem: string) => void;
    setSubMenuClicked: (subMenuClicked: boolean) => void;
    subMenuItem: string;
    mainMenuNavobj?: Navigation;
    subMenuNavObject?: Navigation;
}

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('tablet')]: {
            paddingBottom: '1.875rem',
        },
        [theme.breakpoints.down('tablet')]: {
            height: '100%',
            justifyContent: 'space-between',
            width: '100%',
        },
    },
    item: {
        display: 'flex',
        marginTop: '0.5rem',

        [theme.breakpoints.up(912)]: {
            height: '44px',
        },
        [theme.breakpoints.down(912)]: {
            marginTop: '1.5rem',
        },
    },
    text: {
        display: 'flex',
        width: '361.6666px',
        justifyContent: 'space-between',
        marginRight: '0.625rem',
        [theme.breakpoints.down(912)]: {
            width: '100%',
            color: theme.palette.neutral1,
            alignItems: 'center',
        },
        [theme.breakpoints.only('tablet')]: {
            width: '100%',
            color: theme.palette.neutral1,
            alignItems: 'center',
        },
    },
    image: {
        display: 'flex',
        flexDirection: 'column',
    },
    imageSize: {
        width: '390px',
        height: '219px',
        marginBottom: '10px',
        objectFit: 'cover',
        [theme.breakpoints.down('desktop')]: {
            width: '30vw',
        },
    },
}));

const BodyThirdLevelMenu: React.FC<BodyThirdLevelMenuProps> = (props: BodyThirdLevelMenuProps) => {
    const theme = useTheme();
    const classes = useStyles();
    const [thirdLevelSubMenuClicked, setThirdLevelSubMenuClicked] = useState(false);
    const [thirdLevelSubMenuItem, setThirdLevelSubMenuItem] = useState('');
    const [secondLevelSubMenuItem, setSecondLevelSubMenuItem] = useState('');
    const { isDesktop } = useResponsiveHelper();

    const { menuItem, mainMenuItem, subMenuClicked, setSubMenuItem, setSubMenuClicked, subMenuItem, mainMenuNavobj, subMenuNavObject } = props;

    const isCustomMobileOrTablet = useMediaQuery(theme.breakpoints.down(912));

    return (
        <>
            {!isCustomMobileOrTablet &&
                ((subMenuClicked || (!subMenuClicked && thirdLevelSubMenuClicked)) && menuItem === mainMenuItem ? (
                    <Box display="flex">
                        <Box className={classes.container}>
                            {subMenuNavObject?.child?.map((thirdLevelNavItem: Navigation) => {
                                return (
                                    <Box key={thirdLevelNavItem.navText} className={classes.item}>
                                        {thirdLevelNavItem.child !== null && !thirdLevelNavItem.external ? (
                                            <Box
                                                display="flex"
                                                sx={{
                                                    '&:hover': {
                                                        background: theme.palette.neutral8,
                                                    },
                                                    background: thirdLevelSubMenuClicked && thirdLevelSubMenuItem === thirdLevelNavItem.navText ? theme.palette.neutral8 : 'inherit',
                                                }}
                                            >
                                                <Link
                                                    aria-label={thirdLevelNavItem.altTextPath}
                                                    onClick={() => {
                                                        setThirdLevelSubMenuClicked(thirdLevelSubMenuItem === thirdLevelNavItem.navText ? !thirdLevelSubMenuClicked : true);
                                                        setThirdLevelSubMenuItem(thirdLevelNavItem?.navText);
                                                        setSubMenuItem(subMenuItem);
                                                        setSecondLevelSubMenuItem(subMenuItem);
                                                    }}
                                                    alignItems="center"
                                                    marginLeft="2.5rem"
                                                    marginRight="1rem"
                                                    className={classes.text}
                                                    justifyContent={thirdLevelNavItem.external ? 'flex-start' : 'space-between'}
                                                >
                                                    <Typography variant={isDesktop ? TypographyVariants.bodyBold : TypographyVariants.button} marginRight="10px">
                                                        {thirdLevelNavItem.navText}
                                                    </Typography>
                                                    <ChevronRightLogo sx={{ color: theme.palette.primary1 }} />
                                                </Link>
                                            </Box>
                                        ) : (
                                            <Box
                                                display="flex"
                                                sx={{
                                                    width: '100%',
                                                    '&:hover': {
                                                        background: theme.palette.neutral8,
                                                    },
                                                }}
                                            >
                                                <Link
                                                    aria-label={thirdLevelNavItem.altTextPath}
                                                    href={thirdLevelNavItem.path}
                                                    target={thirdLevelNavItem.external ? '_blank' : '_self'}
                                                    alignItems="center"
                                                    marginLeft="2.5rem"
                                                    marginRight="1rem"
                                                    rel="noopener noreferrer"
                                                    onClick={() => {
                                                        setThirdLevelSubMenuClicked(false);
                                                        setSubMenuClicked(false);
                                                    }}
                                                    className={classes.text}
                                                    justifyContent={thirdLevelNavItem.external ? 'flex-start' : 'space-between'}
                                                >
                                                    <Typography variant={isDesktop ? TypographyVariants.bodyBold : TypographyVariants.button} marginRight="10px">
                                                        {thirdLevelNavItem.navText}
                                                    </Typography>
                                                    {thirdLevelNavItem.external ? (
                                                        <ExternalLinkLogo
                                                            titleAccess={thirdLevelNavItem.altTextIcon}
                                                            sx={{
                                                                height: '16px',
                                                                filter: 'brightness(0) saturate(100%) invert(0%) sepia(59%) saturate(1143%) hue-rotate(104deg) brightness(107%) contrast(105%)',
                                                            }}
                                                        />
                                                    ) : null}
                                                </Link>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                        <Divider orientation="vertical" flexItem />
                    </Box>
                ) : (
                    mainMenuNavobj?.cardBean?.image1 && (
                        <Box className={classes.image} pl={3} pt={3} pr={1.5} pb={9}>
                            <img
                                src={mainMenuNavobj?.cardBean?.image1}
                                title={mainMenuNavobj?.cardBean?.alternateTextForImage1}
                                alt={mainMenuNavobj?.cardBean?.alternateTextForImage1}
                                className={classes.imageSize}
                                aspect-ratio="16/9"
                            />
                            {mainMenuNavobj?.cardBean?.label1 && (
                                <ATCOButton
                                    type={ButtonType.TERTIARY_LIGHT}
                                    text={mainMenuNavobj?.cardBean?.label1}
                                    sx={{ typography: 'button' }}
                                    url={mainMenuNavobj.cardBean.link1}
                                    urlExternal={mainMenuNavobj?.cardBean?.externalLink1}
                                    altText={mainMenuNavobj.cardBean.alternateTextForImage1}
                                />
                            )}
                        </Box>
                    )
                ))}
            <BodyFourthLevelMenu
                subMenuItem={subMenuItem}
                secondLevelSubMenuItem={secondLevelSubMenuItem}
                thirdLevelSubMenuClicked={thirdLevelSubMenuClicked}
                subMenuClicked={subMenuClicked}
                mainMenuNavobj={mainMenuNavobj}
                subMenuNavObject={subMenuNavObject}
                thirdLevelMenuNavobj={subMenuNavObject?.child?.find((e: Navigation) => e.navText === thirdLevelSubMenuItem)}
            />
        </>
    );
};

export default BodyThirdLevelMenu;
